export const TEST_IDS = {
    newRadiologicalButton: 'radiological-button-new',
    table: {
        id: 'radiological-table'
    },
    newRadiologicalEquipment: {
        radiologicalEquipmentFields: {
            brand: 'radiologicalEquipmentForm-input-brand',
            model: 'radiologicalEquipmentForm-input-model',
            equipmentType: 'radiologicalEquipmentForm-input-equipmentType',
            substance: 'radiologicalEquipmentForm-input-substance',
            characteristics: 'radiologicalEquipmentForm-input-characteristics',
            radiationType: 'radiologicalEquipmentForm-input-radiationType',
            activityCURIE: 'radiologicalEquipmentForm-input-activityCURIE',
            radioisotopeOfTheSource: 'radiologicalEquipmentForm-input-radioisotopeOfTheSource',
            sourceType: 'radiologicalEquipmentForm-input-sourceType',
            equipmentPowerKVP: 'radiologicalEquipmentForm-input-equipmentPowerKVP',
            equipmentPowerMAP: 'radiologicalEquipmentForm-input-equipmentPowerMAP',
            equipmentPowerMEV: 'radiologicalEquipmentForm-input-equipmentPowerMEV',
            imageProcessing: 'radiologicalEquipmentForm-input-imageProcessing',
            processingMethod: 'radiologicalEquipmentForm-input-processingMethod',
            observations: 'radiologicalEquipmentForm-input-observations'
        },
        dosimetryFormFields: {
            cuit: 'dosimetryForm-input-cuit',
            dosimetryType: 'dosimetryForm-input-dosimetryType',
            dosimetryMethod: 'dosimetryForm-input-dosimetryMethod',
            personalQuantity: 'dosimetryForm-input-personalQuantity'
        },
        responsiblesFormFields: {
            cuit: 'responsiblesForm-input-cuit',
            responsibleName: 'responsiblesForm-input-responsibleName',
            responsibleSurname: 'responsiblesForm-input-responsibleSurname',
            permission: 'responsiblesForm-input-permission',
            professionalLicense: 'responsiblesForm-input-professionalLicense',
            expeditionDate: 'responsiblesForm-input-expeditionDate',
            expirationDate: 'responsiblesForm-input-expirationDate',
            responsibleType: 'responsiblesForm-input-responsibleType',
            individualAuthorization: 'responsiblesForm-input-individualAuthorization',
            specialLicense: 'responsiblesForm-input-specialLicense',
            habilitationAddress: 'responsiblesForm-input-habilitationAddress',
            professionalDegree: 'responsiblesForm-input-professionalDegree'
        },
        buttons: {
            newResponisble: 'responsiblesForm-button-new'
        }
    }
};
